export class PaginatedResponse<T> {
  public page: number;
  public size: number;
  public total: number;
  public items: T[] = [];

  constructor(data: any = {}) {
    this.page = data?.page ?? 0;
    this.size = data?.size ?? data?.page_size ?? 0;
    this.total = data?.total ?? 0;
    this.items = data?.items ?? [];
  }
}
